import { Alert, Button, FormContainer, Stack, TextField } from '@all-manager/design-system-v2'
import { Controller } from 'react-hook-form'
import AuthLayout from '../../../layout/AuthLayout/AuthLayout'
import { useForgotPasswordPage } from './useForgotPasswordPage'

export const ForgotPasswordPage = () => {
  const hook = useForgotPasswordPage()

  return (
    <AuthLayout
      title="Mot de passe oublié ?"
      description="Entrez votre adresse email : nous vous enverrons un lien pour choisir un nouveau mot de passe."
    >
      <FormContainer onSubmit={hook.handleSubmit} noValidate>
        {hook.isSent ? (
          <Alert severity="success">
            Email envoyé. Ouvrez le lien reçu pour choisir un nouveau mot de passe ; pensez à vérifier vos courriers indésirables.
          </Alert>
        ) : null}
        {hook.serverError ? <Alert severity="error">{hook.serverError}</Alert> : null}

        <Controller
          name="email"
          control={hook.form.control}
          render={({ field, fieldState }) => (
            <TextField
              name={field.name}
              inputRef={field.ref}
              onBlur={field.onBlur}
              onChange={field.onChange}
              value={field.value}
              label="Adresse email"
              type="email"
              autoComplete="email"
              fullWidth
              required
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
            />
          )}
        />

        <Stack spacing={1}>
          <Button type="submit" fullWidth variant="contained" loading={hook.isSubmitting}>
            Envoyer le lien
          </Button>
          <Button
            fullWidth
            variant="text"
            href="/login"
            onClick={hook.handleBackClick}
            disabled={hook.isSubmitting}
          >
            Retour à la connexion
          </Button>
        </Stack>
      </FormContainer>
    </AuthLayout>
  )
}
